module.exports = __webpack_public_path__ + "img/YourPostureAndWorkHabits.f49fe0a2.png";